import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { FileAttachmentComponent } from '../attachment/attachment.component';
import { FileService } from 'src/app/core/services/file.service';
@Component({
  selector: 'multiple-file.dialog-component',
  templateUrl: 'multiple-file-dialog.component.html',
  styleUrls: ['./multiple-file-dialog.component.scss'],
  standalone: false,
})
export class MultipleFileDialogComponent implements OnInit {
  attachmnetTypeData: object;
  public documentGrp: UntypedFormGroup;
  public totalDocfiles: Array<File> = [];
  public totalDocFileName = [];
  acceptedFileTypes = "'.doc,docx,.xls,xlsx,.pdf,.jpeg,.jpg,.png,.msg';";
  public fileSizeError: any;
  fileservice: any;
  catagories: any;
  rcvdFilesId: any[] = [];
  fileError: string = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<MultipleFileDialogComponent>,
    private fileService_: FileService,
    @Inject(MAT_DIALOG_DATA) public multipleFilesDialogdata,
    private cdRef: ChangeDetectorRef,
  ) {
    dialogRef.disableClose = true;
    this.attachmnetTypeData = this.multipleFilesDialogdata.attachmentTypes;
  }

  ngOnInit() {
    const oldFiles = this.multipleFilesDialogdata.mappedFiles;
    this.documentGrp = this.formBuilder.group({
      doc_category: '',
      documentFile: new UntypedFormControl(File),
      fileItems: this.getItems(oldFiles),
      // items: this.formBuilder.array([this.createUploadDocuments()])
    });

    oldFiles.forEach((elem) => {
      const fileId = elem.category;
      this.rcvdFilesId.push(fileId);
      this.totalDocfiles.push(elem.file);
    });
  }

  getItems(oldFiles) {
    if (oldFiles && oldFiles.length > 0) {
      const formItems: any[] = [];
      oldFiles.forEach((elem) => {
        const fileName = elem.file.name;
        this.totalDocFileName.push(fileName);
        console.log(this.totalDocFileName);
        formItems.push(this.createUploadDocuments(elem));
      });
      return this.formBuilder.array(formItems);
    } else {
      return this.formBuilder.array([this.createUploadDocuments()]);
    }
  }

  createUploadDocuments(elem?): UntypedFormGroup {
    return this.formBuilder.group({
      doc_category: new UntypedFormControl(elem && elem.category ? elem.category : '', [Validators.required]),
      documentFile: new UntypedFormControl(elem && elem.file ? elem.file : '', [Validators.required]),
    });
  }

  OnClose() {
    this.dialogRef.close();
  }

  get docItems(): UntypedFormArray {
    return this.documentGrp.get('fileItems') as UntypedFormArray;
  }

  addDocItem(): void {
    this.docItems.push(this.createUploadDocuments());
    this.totalDocfiles.push(null);
    this.totalDocFileName.push(null);
  }

  removeDocItem(index: number) {
    this.totalDocfiles.splice(index, 1);
    this.totalDocFileName.splice(index, 1);
    this.docItems.removeAt(index);
    this.rcvdFilesId.splice(index, 1);
  }

  public OnSubmit(formValue_) {
    const mainForm: FormData = new FormData();
    const fileNames_ = [];
    const _fileTypeName_ = [];
    for (let j = 0; j < this.totalDocfiles.length; j++) {
      mainForm.append(this.totalDocFileName[j], this.totalDocfiles[j]);
      fileNames_.push(this.totalDocFileName[j]);
    }
    const filesObj = [];
    const nameCategoryObj = [];
    for (let index = 0; index < formValue_.fileItems.length; index++) {
      const eachObj = {
        doc_category: formValue_.fileItems[index].doc_category,
        file_name: this.totalDocfiles[index],
      };
      filesObj.push(eachObj);
      nameCategoryObj.push({ category: formValue_.fileItems[index].doc_category, file: eachObj.file_name });
    }
    mainForm.append('fileInfo', JSON.stringify(filesObj));
    if (formValue_.fileItems) {
      this.dialogRef.close(nameCategoryObj);
    }
  }

  getExtensionErrorMessage(index) {
    if (
      this.docItems.controls[index]['controls'].documentFile.hasError('fileSizeError') ||
      this.docItems.controls[index]['controls'].documentFile.hasError('fileExtensionError') ||
      this.docItems.controls[index]['controls'].documentFile.hasError('duplicateFileError')
    ) {
      return this.fileError;
    }
  }

  public docFileSlctdEvnt(slctedFile: any, oldIndex) {
    const fileName = slctedFile.target.files[0].name;
    const fileExt = fileName.split('.').pop();
    const prevSlctdFiles = this.multipleFilesDialogdata.previousFiles.concat(this.totalDocFileName);
    const dupFileArr = prevSlctdFiles.filter((elem) => elem == fileName);
    const isDupFile = dupFileArr ? (dupFileArr.length > 0 ? true : false) : false;
    if (slctedFile.target.files && slctedFile.target.files[0]) {
      if (slctedFile.target.files[0].size <= 0) {
        this.fileError = 'Please upload a file which is not blank';
        this.totalDocFileName[oldIndex] = null;
        this.totalDocfiles[oldIndex] = null;
        this.docItems.at(oldIndex).get('documentFile').reset();
        this.docItems.at(oldIndex).get('documentFile').setErrors({ fileSizeError: true });
      } else if (slctedFile.target.files[0].size > 5242880) {
        this.fileError = 'Please upload a file with size less than 5MB';
        this.totalDocFileName[oldIndex] = null;
        this.totalDocfiles[oldIndex] = null;
        this.docItems.at(oldIndex).get('documentFile').reset();
        this.docItems.at(oldIndex).get('documentFile').setErrors({ fileSizeError: true });
      } else if (
        fileExt != 'doc' &&
        fileExt != 'docx' &&
        fileExt != 'pdf' &&
        fileExt != 'xlsx' &&
        fileExt != 'xls' &&
        fileExt != 'png' &&
        fileExt != 'jpg' &&
        fileExt != 'jpeg' &&
        fileExt != 'msg'
      ) {
        this.totalDocFileName[oldIndex] = null;
        this.totalDocfiles[oldIndex] = null;
        this.docItems.at(oldIndex).get('documentFile').reset();
        this.docItems.at(oldIndex).get('documentFile').setErrors({ fileExtensionError: true });
        this.fileError = 'Please upload the correct format doc|docx|pdf|xls|xlsx|png|jpg|jpeg|msg.';
      } else if (isDupFile) {
        this.totalDocFileName[oldIndex] = null;
        this.totalDocfiles[oldIndex] = null;
        this.docItems.at(oldIndex).get('documentFile').reset();
        this.docItems.at(oldIndex).get('documentFile').setErrors({ duplicateFileError: true });
        this.fileError = 'File already present. Please upload a different file';
      } else {
        const reader = new FileReader();
        this.totalDocfiles[oldIndex] = slctedFile.target.files[0];
        this.totalDocFileName[oldIndex] = slctedFile.target.files[0].name;
        reader.readAsDataURL(slctedFile.target.files[0]);
      }
    }
  }
}
